<template>
    <BFormSelect
        :options="the_list"
        :state="input_state"
        :text-field="textField"
        :value-field="valueField"
        v-bind="$attrs"
        :value="value"
        v-on="inputListeners"
    >
        <template v-if="!$attrs.required" #first>
            <option :value="null">{{ blankOptionText }}</option>
        </template>
    </BFormSelect>
</template>

<script>
import { BFormSelect } from "bootstrap-vue";
import VuexInputFieldMixin from "./VuexInputFieldMixin.js";
import SelectInputMixin from "../private/SelectInputMixin.js";

export default {
    name: "OSelectInput",
    components: {
        BFormSelect,
    },
    mixins: [VuexInputFieldMixin(true), SelectInputMixin],
};
</script>

<style scoped></style>
